import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FormDivider from '../common/components/FormDivider'
import AutomatedRemindersSection from '../common/components/formInputs/AutomatedRemindersSection'
import ToggleInput from '../common/components/formInputs/ToggleInput'
import PostEventReviewSection from '../common/components/formInputs/PostEventReviewSection'

const FourthStep = ({ displayStep, formValues, socialLinksOptions, setFieldValue }) => {
  const { t } = useTranslation(['eventManagement'])

  if (!displayStep) {
    return null
  }

  return (
    <React.Fragment>
      <FormDivider />

      <div className="columns">
        <div className="column is-12">
          <p>{t('eventManagement:common.rsvp')}</p>
        </div>
      </div>
      <div className="columns">
        <ToggleInput
          columnSize={12}
          name="hideAttendees"
          value={formValues.hideAttendees}
          label={t('eventManagement:common.hideAttendeeList')}
          tooltip={
            <>
              <p>{t('eventManagement:common.hideAttendeeListTooltipLine1')}</p>
              <p>{t('eventManagement:common.hideAttendeeListTooltipLine2')}</p>
              <p>{t('eventManagement:common.hideAttendeeListTooltipLine3')}</p>
            </>
          }
          onToggle={setFieldValue}
        />
      </div>

      <FormDivider />

      <div className="columns">
        <div className="column is-12">
          <p>{t('eventManagement:common.communication')}</p>
        </div>
      </div>
      <AutomatedRemindersSection
        automatedRemindersToggle={formValues.automatedRemindersToggle}
        remindRsvp={formValues.remindRsvp}
        remindRsvpValues={formValues.remindRsvpValues}
        remindAll={formValues.remindAll}
        remindAllValues={formValues.remindAllValues}
        timeStart={formValues.timeStart}
        setFieldValue={setFieldValue}
      />
      <PostEventReviewSection
        askForPostEventReview={formValues.askForPostEventReview}
        positiveReview={formValues.positiveReview}
        socialLinksOptions={socialLinksOptions}
        socialLinkService={formValues.socialLinkService}
        setFieldValue={setFieldValue}
      />

      <FormDivider />
    </React.Fragment>
  )
}

FourthStep.propTypes = {
  displayStep: PropTypes.bool,
  formValues: PropTypes.object.isRequired,
  socialLinksOptions: PropTypes.array,
  setFieldValue: PropTypes.func.isRequired,
}

export default FourthStep
